export default __webpack_public_path__ + "static/media/_DSC0931.327084b5.JPG";